/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DBResourceMetadata } from '../models/DBResourceMetadata';
import { DBSnapshotMetadata } from '../models/DBSnapshotMetadata';
import { UnifiedDatabaseRecord } from '../models/UnifiedDatabaseRecord';

export class UnifiedDBServerRecord {
  /**
  * The ID of the server
  */
  'serverId': string;
  /**
  * The name of the server
  */
  'serverName': string;
  /**
  * The type of the server (i.e EC2, RDS, etc)
  */
  'serverType': string;
  /**
  * The type of the engine (i.e MySQL, Postgres, etc)
  */
  'engineType': string;
  /**
  * The version of the engine (i.e 11.1.4)
  */
  'engineVersion': string;
  /**
  * Number of dbs under this server
  */
  'dbCount': number;
  /**
  * dbs under this server (optional)
  */
  'databases'?: Array<UnifiedDatabaseRecord>;
  /**
  * reserved for elastic use
  */
  'recordType'?: string;
  'snapshot': DBSnapshotMetadata;
  'resource': DBResourceMetadata;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "serverId",
      "baseName": "serverId",
      "type": "string",
      "format": ""
    },
    {
      "name": "serverName",
      "baseName": "serverName",
      "type": "string",
      "format": ""
    },
    {
      "name": "serverType",
      "baseName": "serverType",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineType",
      "baseName": "engineType",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineVersion",
      "baseName": "engineVersion",
      "type": "string",
      "format": ""
    },
    {
      "name": "dbCount",
      "baseName": "dbCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "databases",
      "baseName": "databases",
      "type": "Array<UnifiedDatabaseRecord>",
      "format": ""
    },
    {
      "name": "recordType",
      "baseName": "record_type",
      "type": "string",
      "format": ""
    },
    {
      "name": "snapshot",
      "baseName": "snapshot",
      "type": "DBSnapshotMetadata",
      "format": ""
    },
    {
      "name": "resource",
      "baseName": "resource",
      "type": "DBResourceMetadata",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UnifiedDBServerRecord.attributeTypeMap;
  }

  public constructor() {
  }
}

